export function isLocalDevelopmentEnvironment(config) {
	return config && config.deployEnv
		? ['development', 'local'].includes(config.deployEnv)
		: process.env.NODE_ENV === 'development'
}
